import { render, staticRenderFns } from "./ForumView.vue?vue&type=template&id=22070fee&scoped=true&"
import script from "./ForumView.vue?vue&type=script&lang=js&"
export * from "./ForumView.vue?vue&type=script&lang=js&"
import style0 from "./ForumView.vue?vue&type=style&index=0&id=22070fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22070fee",
  null
  
)

export default component.exports